<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          {{ total }} Options
          <!-- <span class="">Options</span> -->
        </h1>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <div class="field">
              <div class="control">
                <multiselect
                  label="name"
                  track-by="pk"
                  :searchable="true"
                  :show-labels="false"
                  :multiple="true"
                  class="multiselect--option-ico"
                  :placeholder="''"
                  @input="updateSimpleFilter"
                  @search-change="getProgramsByName"
                  @open="!programsFilter.length ? getProgramsByName() : null"
                  :loading="loadingFilters === 'program'"
                  v-model="filters.programs"
                  open-direction="bottom"
                  :options="programsFilter"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :hide-selected="true">
                  <template
                    slot="tag"
                    slot-scope="props">
                    <span></span>
                  </template>
                  <template
                    slot="selection"
                    slot-scope="{ values, isOpen }">
                    <span
                      v-if="values.length && !isOpen"
                      class="multiselect__placeholder">
                      Programmes ({{ values.length }})
                    </span>
                  </template>
                  <template slot="beforeList">
                    <li class="multiselect__element">
                      <span
                        @click="toggleAllPrograms"
                        @mouseenter="hoveredAllPrograms = true"
                        @mouseleave="hoveredAllPrograms = false"
                        class="multiselect__option"
                        :class="{
                          'multiselect__option--selected': filters.programs && filters.programs.length === programsFilter.length,
                          'multiselect__option--highlight': hoveredAllPrograms
                        }">
                        <span>Tous les programmes</span>
                      </span>
                    </li>
                  </template>
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="programs.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun programme trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Programmes</span>
                </multiselect>
              </div>
            </div>
            <!-- <div class="field">
              <div class="control">
                <multiselect
                  v-model="filters.lot"
                  label="ref"
                  track-by="pk"
                  :options="lots"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :placeholder="''"
                  :custom-label="val => limitText(`${val.ref} (${val.program.name})`)"
                  @select="updateSimpleFilter"
                  @remove="updateFilter([], 'lot')"
                  @search-change="getLots">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="lots.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun lot trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Lot</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Lot</span>
                </multiselect>
              </div>
            </div> -->
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="filters.user"
                  label="name"
                  track-by="pk"
                  :options="usersFilter"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :custom-label="val => limitText(`${val.last_name} ${val.first_name}`)"
                  :placeholder="''"
                  @select="updateSimpleFilter"
                  @remove="updateFilter([], 'user')"
                  @search-change="getSellersByName"
                  @open="getSellersByName">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="users.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun vendeur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Vendeur</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Vendeur</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="!isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.promoteur"
                  label="name"
                  track-by="pk"
                  :options="promoteurs"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :placeholder="''"
                  @select="updateSimpleFilter"
                  @remove="updateFilter([], 'promoteur')"
                  @search-change="getPromoteurs">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="promoteurs.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun promoteur trouvé.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Promoteur</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Promoteur</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="isPromoteur"
              class="field">
              <div class="control">
                <multiselect
                  v-model="filters.account"
                  label="name"
                  track-by="pk"
                  :options="companiesFilter"
                  :searchable="true"
                  :show-labels="false"
                  class="multiselect--option-ico is-single_choice"
                  :placeholder="''"
                  @select="updateSimpleFilter"
                  @remove="updateFilter([], 'account')"
                  @search-change="getCompaniesByName">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      v-if="accounts.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)" />
                  </template>
                  <span slot="noResult">Oups! Aucun société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span
                    slot="singleLabel"
                    class="multiselect__placeholder">Société</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Société</span>
                </multiselect>
              </div>
            </div>
            <div
              v-if="(isAdmin && isPromoteur) || currentUser.active_all_contact"
              class="field">
              <div class="control">
                <multiselect
                  @input="updateSimpleFilter"
                  @search-change="getAgenceByName"
                  @open="!programsFilter.length ? getAgenceByName() : null"
                  :loading="loadingFilters === 'agence'"
                  v-model="filters.agence"
                  label="name"
                  track-by="pk"
                  class="multiselect--option-ico is-single_choice"
                  open-direction="bottom"
                  :multiple="true"
                  :options="agencesFilter"
                  :searchable="true"
                  :close-on-select="false"
                  :show-labels="false"
                  :placeholder="''">
                  <span slot="noResult">Oups! Aucune agence trouvée.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Agences</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Agences ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <multiselect
                  v-model="filters.origin"
                  v-if="origins"
                  track-by="pk"
                  @input="updateSimpleFilter"
                  class="multiselect--option-ico"
                  :custom-label="val => val.name"
                  :value="filters.origin"
                  :close-on-select="false"
                  group-values="children"
                  group-label="name"
                  :group-select="true"
                  :multiple="true"
                  :options="activeOriginGroups"
                  :searchable="true"
                  :show-labels="false"
                  @search-change="getOriginsByName"
                  :placeholder="''">
                  <template
                    slot="clear"
                    slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="origins.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucune origine trouvée.</span>
                  <span
                    slot="placeholder"
                    class="multiselect__placeholder">Origine(s)</span>
                  <span
                    slot="selection"
                    class="multiselect__placeholder"
                    slot-scope="{ values }"
                    v-if="values.length">
                    <span>Origine(s) ({{ values.length }})</span>
                  </span>
                  <span slot="noOptions">La liste est vide</span>
                </multiselect>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <div class="select is-fullwidth">
                  <select
                    id="reservation__status"
                    v-model="filters.reservation__status"
                    @input="updateSimpleFilter">
                    <option :value="null">
                      Dossier de reservation
                    </option>
                    <option :value="'pending'">
                      En attente
                    </option>
                    <option :value="'refused'">
                      Refusé
                    </option>
                    <option :value="'editing'">
                      Édition
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{created_on__gte: filters.created_on__gte, created_on__lte: filters.created_on__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Date de création'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{previous_sign_date__gte: filters.previous_sign_date__gte, previous_sign_date__lte: filters.previous_sign_date__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Date réservation prévue'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <date-picker
                  :model="{canceled_date__gte: filters.canceled_date__gte, canceled_date__lte: filters.canceled_date__lte}"
                  :style-version="2"
                  :is-range="true"
                  :name="'date'"
                  :placeholder="'Date d\'annulation'"
                  :config="{mode: 'range'}"
                  @input="Object.assign(filters, $event); updateSimpleFilter()" />
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <div>
        <list-top-bar
          :counted="count"
          label="option(s)"
          :has-filtered="hasFilter"
          :display-export="true"
          :not-export-all="true"
          :child-action-group="parentActionGroup"
          @update:childActionGroup="handleActionGroupUpdate">
        </list-top-bar>
        <div class="is-flex is-space-between is-border-left is-border-right is-border-bottom has-background-white">
          <div
            class="field is-grouped is-padding-small"
            style="margin-bottom: 0">
            <p
              v-for="status in activationStatus"
              :key="status.value"
              class="control">
              <label
                class="checkbox checkRadioIsHide"
                :for="status.value">
                <input
                  :id="status.value"
                  v-model="filters.status"
                  :name="status.name"
                  type="checkbox"
                  :value="status.value"
                  @click="updateSimpleFilter">
                <span
                  class="tag"
                  :class="status.color">
                  <span>{{ status.label }}</span><span class="icon"><i
                    class="far"
                    :class="filters.status.includes(status.value) ? 'fa-check-square' : 'fa-square'" /></span>
                </span>
              </label>
            </p>
          </div>
          <div
            class="column is-narrow is-paddingless is-border-left container-btn-export-option"
            v-if="multiselection && parentActionGroup">
            <a
              @click="selectedItems.length ? (exportXlsFromMultiselect(service, 'list-option'), cancelSelect()) : ''"
              :style="selectedItems.length ? 'background-color: #8dbb7d; color: white; cursor: pointer' : 'cursor: default; color: #D7D7D7'"
              class="btn_export_option is-uppercase">
              <span class="icon"><i class="fas fa-file-excel"></i></span><span>Exporter Options</span>
            </a>
          </div>
        </div>
        <filters-tags
          id="option-tag"
          :has-filter="hasFilter"
          :filters="filters"
          :ignore-tags="['status']"
          @reset="resetFilters"
          @update="updateFromTag($event)" />
        <spinner-round
          v-if="loading"
          :is-loading="loading" />
        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="true"
          classes="is-marginless-bottom">
          <table class="table is-narrow is-fullwidth is-striped-v is-first-fixed-small is-last-fixed-small has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th
                  class="is-paddingless has-text-centered"
                  style="z-index:2;">
                  <columns-toggles
                    :entries="columnsList"
                    :source="columns"
                    @update="updateColumns" />
                </th>
                <th v-if="isPromoteur">
                  <span class="is-padding-xsmall">Statut</span>
                </th>
                <th>
                  <sortable
                    sort-id="lot__ref"
                    :sort="sortBy.lot__ref"
                    label="Lot"
                    @sort="sort('lot__ref', $event)" />
                </th>
                <th v-if="showColumn('sale_price_ht')">
                  <sortable
                    sort-id="lot__sale_price_ht"
                    :sort="sortBy.lot__sale_price_ht"
                    label="Prix de vente HT"
                    @sort="sort('lot__sale_price_ht', $event)" />
                </th>
                <th v-if="showColumn('sale_price_ttc')">
                  <sortable
                    sort-id="lot__sale_price_ttc"
                    :sort="sortBy.lot__sale_price_ttc"
                    label="Prix de vente TTC"
                    @sort="sort('lot__sale_price_ttc', $event)" />
                </th>
                <th v-if="showColumn('program__name')">
                  <sortable
                    sort-id="program__name"
                    :sort="sortBy.program__name"
                    label="Programme"
                    @sort="sort('program__name', $event)" />
                </th>
                <th
                  v-if="showColumn('origin__name')"
                  class="is-groupcols-1a">
                  <sortable
                    @sort="sort('origin__name', $event)"
                    sort-id="origin__name"
                    :sort="sortBy.origin__name"
                    label="Origine"></sortable>
                  <!-- <div class="deco"></div> -->
                </th>
                <th v-if="!isPromoteur && showColumn('promoteur__name')">
                  <sortable
                    sort-id="promoteur__name"
                    :sort="sortBy.promoteur__name"
                    label="Promoteur"
                    @sort="sort('promoteur__name', $event)" />
                </th>
                <th v-if="isPromoteur && showColumn('account__name')">
                  <sortable
                    sort-id="account__name"
                    :sort="sortBy.account__name"
                    label="Société"
                    @sort="sort('account__name', $event)" />
                </th>
                <th v-if="showColumn('user__last_name') && (isAdmin || isManager)">
                  <sortable
                    sort-id="user__last_name"
                    :sort="sortBy.user__last_name"
                    label="Vendeur"
                    @sort="sort('user__last_name', $event)" />
                </th>
                <th v-if="showColumn('contact__last_name')">
                  <sortable
                    sort-id="contact__last_name"
                    :sort="sortBy.contact__last_name"
                    label="Contact"
                    @sort="sort('contact__last_name', $event)" />
                </th>
                <th v-if="showColumn('created_on')">
                  <sortable
                    sort-id="created_on"
                    :sort="sortBy.created_on"
                    label="Date de création"
                    @sort="sort('created_on', $event)" />
                </th>
                <th v-if="showColumn('start_date')">
                  <sortable
                    sort-id="start_date"
                    :sort="sortBy.start_date"
                    label="Date de début"
                    @sort="sort('start_date', $event)" />
                </th>
                <th v-if="showColumn('end_date')">
                  <sortable
                    sort-id="end_date"
                    :sort="sortBy.end_date"
                    label="Date de fin"
                    @sort="sort('end_date', $event)" />
                </th>
                <th v-if="showColumn('previous_sign_date')">
                  <sortable
                    sort-id="previous_sign_date"
                    :sort="sortBy.previous_sign_date"
                    label="Réservation prévue"
                    @sort="sort('previous_sign_date', $event)" />
                </th>
                <th v-if="showColumn('canceled_date')">
                  <sortable
                    sort-id="canceled_date"
                    :sort="sortBy.canceled_date"
                    label="Date d'annulation"
                    @sort="sort('canceled_date', $event)" />
                </th>
                <th v-if="showColumn('dossier_reservation')">
                  <span>Dossier de réservation</span>
                </th>
                <th class="has-text-centered" />
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr>
                <td
                  v-if="multiselection"
                  colspan="16"
                  style="padding: 0">
                  <div
                    class="is-flex is-nowrap is-align-items-center container_select_multiple_option">
                    <a
                      :style="!selectedItems.length > 0? 'background-color: #219CED' : 'background-color: #8CBB7D'"
                      class="select_multiple_option"
                      @click="$store.commit('selectAllMultiselectionItems')">
                      <i
                        style="font-size: 17px; padding: 0px 20px 0px 13px"
                        class="far fa-check-double"></i>
                      <span class="is-padding-left-xxsmall">{{ !selectedItems.length > 0 ? 'Cliquez ici pour sélectionner toutes les lignes de la page' : 'Déselectionnez toutes les lignes de la page' }}</span>
                    </a>
                  </div>
                </td>
              </tr>
              <tr
                v-for="(option) in items"
                :id="'e' + option.pk"
                :key="option.pk"
                class="is-size-6"
                :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === option.pk}">
                <td
                  v-if="isPromoteur"
                  @click="openCommentView(option)"
                  class="has-cursor-pointer is-cell-hoverable">
                  <div
                    class="is-flex-center has-background-white comment-icon"
                    v-if="option.comment">
                    <span
                      style="border-color: #FFFFFF;"
                      class="orange-bullet"></span>
                    <span
                      class="icon is-size-5 has-text-grey icon-margin">
                      <i class="fas fa-sticky-note"></i>
                    </span>
                  </div>
                  <div
                    class="is-flex-center has-background-white comment-icon"
                    v-else>
                    <span
                      class="icon is-size-5 has-text-grey icon-margin">
                      <i class="fal fa-sticky-note"></i>
                    </span>
                  </div>
                </td>
                <td class="is-paddingless has-text-centered is-vcentered">
                  <multiselect-button
                    v-if="multiselection"
                    :data="option" />
                  <span
                    v-else
                    :data-tooltip="optionStatus[option.status].label"
                    class="dot tooltip is-tooltip-right"
                    :class="option.status | dotClass" />
                </td>
                <td class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'LotVue', params: {id: option.lot.pk}}"
                    class="fullLink">
                    {{ option.lot.ref }}
                  </router-link>
                </td>
                <td
                  v-if="showColumn('sale_price_ht')"
                  class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'LotVue', params: {id: option.lot.pk}}"
                    class="fullLink">
                    <span v-if="option.lot.sale_price_ht && !option.lot.tva_on_marge">{{ option.lot.sale_price_ht | prettyPrice }} €</span>
                    <span v-else-if="option.lot.tva_on_marge">TVA sur marge</span>
                  </router-link>
                </td>
                <td
                  v-if="showColumn('sale_price_ttc')"
                  class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'LotVue', params: {id: option.lot.pk}}"
                    class="fullLink">
                    {{ option.lot.sale_price_ttc | prettyPrice }} €
                  </router-link>
                </td>
                <td
                  v-if="showColumn('program__name')"
                  class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'ProgramVue', params: {id: option.program.pk}}"
                    class="fullLink">
                    {{ option.program.name }}
                  </router-link>
                </td>
                <td
                  v-if="showColumn('origin__name')"
                  class="is-cell-hoverable is-narrow is-truncate">
                  <span
                    v-if="isPromoteur && option.contact.origin && (currentUser.account.pk === option.contact.account.pk)"
                    :title="option.contact.origin.name">
                    {{ option.contact.origin.name }}
                  </span>
                  <span
                    v-else-if="isDistributeur && option.contact.origin && (option.contact.shared === true || option.contact.account.pk === currentUser.account.pk)"
                    :title="option.contact.origin.name">
                    {{ option.contact.origin.name }}
                  </span>
                  <span v-else>-</span>
                </td>
                <!-- <td
                  v-if="!isPromoteur && showColumn('promoteur__name') && isPromoteurDetailsActivated(option)"
                  class="is-cell-hoverable is-narrow">
                  <router-link
                    :to="{name: 'PromoteurPresentation', params: {id: option.promoteur.pk}}">
                    <span class="">{{ option.promoteur.name }}</span>
                  </router-link>
                </td> -->
                <td v-if="!isPromoteur && showColumn('promoteur__name')">
                  {{ option.promoteur.name }}
                </td>
                <td
                  v-if="isPromoteur && showColumn('account__name')"
                  :class="{'is-cell-hoverable' : isAdmin && option.account.pk !== currentUser.account.pk}">
                  <router-link
                    v-if="isAdmin && option.account.pk !== currentUser.account.pk"
                    :to="{name: 'CompanyVue', params: {id: option.account.pk}}"
                    class="fullLink">
                    {{ option.account.name }}
                  </router-link>
                  <span v-else>
                    {{ option.account.name }}
                  </span>
                </td>
                <td
                  v-if="showColumn('user__last_name') && (isAdmin || isManager)"
                  class="is-cell-hoverable">
                  <router-link
                    :to="{name: 'UserVue', params: {id: option.user.pk}}"
                    class="fullLink">
                    {{ option.user.last_name }}  {{ option.user.first_name }}
                  </router-link>
                </td>
                <td
                  v-if="showColumn('contact__last_name')"
                  :class="{'is-cell-hoverable' : (option.contact.account.pk === currentUser.account.pk) || (option.contact.account.pk !== currentUser.account.pk && option.user.pk === currentUser.pk) }">
                  <router-link
                    v-if="(option.contact.account.pk === currentUser.account.pk) || (option.contact.account.pk !== currentUser.account.pk && option.user.pk === currentUser.pk)"
                    :to="{name: 'ContactVue', params: {id: option.contact.pk}}"
                    class="fullLink">
                    {{ option.contact.last_name }}  {{ option.contact.first_name }}
                  </router-link>
                  <template v-else>
                    {{ option.contact.last_name }}  {{ option.contact.first_name }}
                  </template>
                </td>
                <td v-if="showColumn('created_on')">
                  {{ option.created_on | prettyDate }}
                </td>
                <td v-if="showColumn('start_date')">
                  {{ option.start_date | prettyDate }}
                </td>
                <td v-if="showColumn('end_date')">
                  {{ option.end_date | prettyDate }}
                </td>
                <td v-if="showColumn('previous_sign_date')">
                  {{ option.previous_sign_date | prettyDate }}
                </td>
                <td v-if="showColumn('canceled_date')">
                  {{ option.canceled_date | prettyDate }}
                </td>
                <td v-if="showColumn('dossier_reservation')">
                  <span v-if="option.status === 'approved' && 'reservation' in option && option.reservation"> {{ option.reservation.status|reservationStatus }} </span>
                  <span v-else> -- </span>
                </td>
                <td>
                  <display-button-list
                    :buttons="buttonList"
                    :data="option"
                    :hide-text-when-solo="true" />
                </td>
              </tr>
              <!--<tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>-->
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucune option en cours
            </h2>
            <a
              v-if="hasFilter"
              class="has-text-primary"
              @click="resetFilters"><span class="icon is-medium"><i class="fal fa-undo-alt" /></span> <span>Afficher l'historique des options</span></a>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)" />
      </div>
    </page-content>
  </div>
</template>

<script>
import { bus, EVENTS } from '@/bus'
import { GenericList, Filter, Sort, DefaultValues, ColumnConf, Option, FilterGetter, Multiselection, Quickview } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import UploadMixin from '../../mixins/UploadMixin'

export default {
  name: 'OptionList',
  filters: {
    reservationStatus (value) {
      const STATUS = {
        'pending': 'En attente',
        'refused': 'Refusé',
        'editing': 'Édition'
      }
      return STATUS[value]
    }
  },
  mixins: [GenericList,
    Filter,
    Sort,
    DefaultValues,
    ColumnConf,
    Option,
    FilterGetter,
    Multiselection,
    Quickview,
    UploadMixin
  ],
  data () {
    return {
      setQueryAtStart: true,
      columnsConfResource: 'options',
      hoveredAllPrograms: false,
      buttonList: [
        {
          action: (id, option) => {
            this.$store.commit('setQuickview', { mode: 'OPTION_UPDATE_DATE', params: { source: option } })
          },
          icon: 'fa-clock',
          text: 'Modifier date de fin',
          needProfile: ['admin', 'manager'],
          display: (o) => {
            return this.canUpdateOption(o)
          }
        },
        {
          action: (id, option) => {
            this.$router.push({ name: 'PreReservation', params: { id: option.reservation.pk } })
          },
          icon: 'fa-handshake',
          text: 'Passer en pré-réservation',
          display: (o) => {
            if ((((this.isAdmin && !this.isPromoteur) || this.isManager) && o.account.pk === this.currentUser.account.pk) || (o.user.pk === this.currentUser.pk && !(this.isPromoteur && this.isAdmin))) {
              return o.status === 'approved' && o.reservation.status !== 'pending'
            }
          }
        },
        {
          action: (id, option) => {
            this.$router.push({ name: 'PreReservation', params: { id: option.reservation.pk } })
          },
          icon: 'fa-handshake',
          text: 'Gerer la pré-réservation',
          display: (o) => {
            if (this.isPromoteur && this.isAdmin) {
              if (o.user.pk === this.currentUser.pk) {
                return o.status === 'approved'
              } else if (o.status === 'waiting_list') {
                return false
              } else if (o.user.pk !== this.currentUser.pk && o.contact.account.pk === this.currentUser.account.pk) {
                return o.status === 'approved'
              } else {
                return (('reservation' in o && o.reservation.status === 'pending') || (o.account.pk === this.currentUser.account.pk)) && o.status !== 'canceled' && o.status !== 'canceled_auto' && o.status !== 'expired'
              }
            }
          }
        },
        {
          action: (id) => {
            this.confirmDelete().then(r => {
              if (r.value) {
                this.updateOption(id, { status: 'canceled' }, 'L\'option a été annulée.')
              }
            })
          },
          icon: 'fa-trash-alt',
          text: 'Annuler',
          display: (o) => {
            return this.canUpgrade(o.status) && (this.isAdmin || o.user.pk === this.currentUser.pk || this.isInUserTeam(o.user.pk) || this.currentUser.active_all_contact)
          }
        }
      ],
      loadDocuments: this.loadItems,
      filters: {
        account: null,
        program: null,
        // lot: null,
        user: null,
        origin: [],
        created_on__gte: null,
        created_on__lte: null,
        reservation__status: null,
        canceled_date__gte: null,
        canceled_date__lte: null,
        status: ['approved', 'waiting_list'],
        agence: []
      },
      initFilters: {
        account: null,
        program: null,
        // lot: null,
        user: null,
        origin: [],
        created_on__gte: null,
        created_on__lte: null,
        reservation__status: null,
        canceled_date__gte: null,
        canceled_date__lte: null,
        status: ['approved', 'waiting_list'],
        agence: []
      },
      service: 'OPTION',
      items: [],
      origins: [],
      openedCol: false,
      activationStatus: [
        { value: 'approved', label: 'Accepté', color: 'is-success' },
        { value: 'waiting_list', label: 'En liste d\'attente', color: 'is-warning' },
        { value: 'expired', label: 'Expiré', color: 'is-draft' },
        { value: 'canceled', label: 'Annulé', color: 'is-danger' },
        { value: 'canceled_auto', label: 'Annulée par Vadimm', color: 'is-danger' }
      ],
      optionsForExport: [],
      bigExport: false,
      optionsLoading: false,
      parentActionGroup: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'activeOriginGroups', 'isDistributeur']),
    ...mapGetters({ storeAccounts: 'accounts' }),
    ...mapState(['savedFilters', 'lastOpenedItemPk']),

    columnsShow () {
      let columns = {
        program__name: { label: 'Programme', mobile: true }
      }
      if (!this.isPromoteur) {
        columns.promoteur__name = { label: 'Promoteur', mobile: true }
      }
      if (this.isPromoteur) {
        columns.account__name = { label: 'Société', mobile: true }
      }
      if (this.isAdmin || this.isManager) {
        columns.user__last_name = { label: 'Vendeur', mobile: true }
      }
      columns.contact__last_name = { label: 'Contact', mobile: true }
      columns.created_on = { label: 'Date de création', mobile: true }
      columns.start_date = { label: 'Date de début', mobile: true }
      columns.end_date = { label: 'Date de fin', mobile: true }
      columns.sale_price_ht = { label: 'Prix HT', mobile: true }
      columns.sale_price_ttc = { label: 'Prix TTC', mobile: true }
      columns.previous_sign_date = { label: 'Réservation prévue', mobile: true }
      columns.dossier_reservation = { label: 'Dossier de réservation', mobile: true }
      columns.canceled_date = { label: 'Date d\'annulation', mobile: true }
      columns.origin__name = { label: 'Origine', mobile: true }
      return columns
    }
  },
  watch: {
    quickview ({ mode, params, results }) {
      if (results && mode === 'OPTION_UPDATE_DATE') {
        let params = {
          end_date: results.date
        }
        this.updateOption(results.option.pk, params, 'L\'option a été mise à jour.')
      }
      if (!mode && !params && !results) {
        this.loadDocuments()
      }
    }
    // bigExport (to) {
    //   if (to) {
    //     const documentName = 'Liste des options'
    //     const service = this.service
    //     this.sendBigExport(documentName, service, this.optionsForExport)
    //   }
    // }
  },
  created () {
    if (this.$route.query && this.$route.query.reservation__status) {
      this.filters = { ...this.filters, reservation__status: this.$route.query.reservation__status }
    } else if ('optionList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
      this.cancelSelect()
    }
    this.getOrigins()
    this.getCompaniesByName()
    bus.$on(EVENTS.OPTION_UPDATED, () => { this.loadDocuments() })
    bus.$on(EVENTS.OPTION_CANCELED, () => { this.loadDocuments() })
    bus.$on(EVENTS.OPTION_EXTENDED, () => { this.loadDocuments() })
    bus.$on(EVENTS.OPTION_CREATED, () => { this.loadDocuments() })
  },
  mounted () {
    if ('optionList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
  },
  destroyed () {
    bus.$off(EVENTS.OPTION_UPDATED)
    bus.$off(EVENTS.OPTION_CANCELED)
    bus.$off(EVENTS.OPTION_EXTENDED)
    bus.$off(EVENTS.OPTION_CREATED)
  },
  methods: {
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.optionList)
      this.updateSimpleFilter()
    },
    async getOrigins () {
      try {
        const { data } = await this.$api.get(this.$resources.ORIGIN, { sort: 'name:asc' })
        this.origins = data.items
      } catch (e) {
        console.log(e)
      }
    },
    isPromoteurDetailsActivated (option) {
      return this.storeAccounts.find(a => a.name === option.promoteur.name)
    },
    /**
      * function to use before load items
      * prepare query
      * loadItems in GenericListMixin.js
      */
    beforeGet () {
      // if (this.query.program) {
      //   this.query.program = this.query.program.pk
      // }
      // if (this.query.lot) {
      //   this.query.lot = this.query.lot.pk
      // }
      if (this.query.promoteur) {
        this.query.promoteur = this.query.promoteur.pk
      }
      if (this.query.account && typeof this.query.account !== 'string') {
        this.query.account = this.query.account.pk
      }
      if (this.query.user) {
        this.query.user = this.query.user.pk
      }
      if (this.query.user__account) {
        this.query.user__account = this.query.user__account.pk
      }

      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'optionList', name: key, value: this.filters[key] })
      }
    },
    /**
      * Change root
      */
    goToRoute (link) {
      this.$router.push({ name: link })
    },
    openCommentView (option) {
      let note = {
        message: option.comment,
        type: 'optionComment',
        updated_on: option.updated_on
      }
      this.openNoteQuickviewOption({ item: note }, option.pk)
    },
    /**
    * open note quickview
    * @param {object} item - note content
    */
    openNoteQuickviewOption ({ item } = {}, optionPk = '') {
      this.$store.commit('setQuickview', { mode: 'NOTE_CREATE', params: { source: item, optionPk } })
    },
    handleActionGroupUpdate (newValue) {
      this.parentActionGroup = newValue
    },
    // async ExportAllOptions () {
    //   let params = {
    //     type: 'export',
    //     status: this.filters.status
    //   }
    //   this.advLoading = true
    //   try {
    //     const { data } = await this.$api.get(this.$resources.OPTION, params)
    //     for (let option of data.items) {
    //       this.optionsForExport.push(option.pk)
    //     }
    //     if (this.optionsForExport.length < 150) {
    //       this.$store.commit('setSelectedItems', this.optionsForExport)
    //       this.exportXlsFromMultiselect('OPTION', 'liste-options')
    //     } else {
    //       this.bigExport = true
    //       this.$toasted.global.success('Vous allez recevoir vos fichiers par mail')
    //     }
    //     this.advLoading = false
    //   } catch (e) {
    //     console.log(e)
    //     this.advLoading = false
    //     this.$toasted.global.danger('Erreur lors de l\'envoie des advs')
    //   }
    // },
    cancelSelect () {
      this.parentActionGroup = false
      this.$store.commit('cancelMultiselection')
    },
    toggleAllPrograms () {
      if (this.filters.programs && this.filters.programs.length === this.programsFilter.length) {
        // Si tous les programmes sont déjà sélectionnés, les désélectionner tous
        this.filters.programs = []
      } else {
        // Ajouter tous les programmes à la sélection existante (sans doublons)
        const currentSelection = this.filters.programs || []
        const allPrograms = [...this.programsFilter]
        // Fusionner les deux listes en évitant les doublons
        const merged = [...currentSelection]
        allPrograms.forEach(program => {
          if (!merged.find(p => p.pk === program.pk)) {
            merged.push(program)
          }
        })
        this.filters.programs = merged
      }
      this.updateSimpleFilter()
    }
  }
}
</script>

<style lang="sass">

.container-btn-export-option
  width: 217px
  flex: 0 0 auto

.btn_export_option
  background-color: #fff
  color: #7a7a7a
  width: 100%
  min-height: 100%
  font-size: 1.2rem
  display: flex
  align-items: center
  justify-content: center

.container_select_multiple_option
  width: 100%

.select_multiple_option
  text-decoration: none !important
  padding: 13px
  width: 100%
  color: white

.select_multiple_option:hover
  color: white
  text-decoration: none

</style>
